"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLambdaProxyError = exports.getLambdaProxyResponse = exports.HttpMethods = exports.StatusCodes = exports.httpReturnSafeError = exports.replaceErrors = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
Object.defineProperty(exports, "replaceErrors", { enumerable: true, get: function () { return iotv_v3_types_1.replaceErrors; } });
Object.defineProperty(exports, "httpReturnSafeError", { enumerable: true, get: function () { return iotv_v3_types_1.httpReturnSafeError; } });
const debug_1 = require("./debug");
const debug = debug_1.DEBUG_OVERRIDE || (debug_1.NOT_LAMBDA && false);
var StatusCodes;
(function (StatusCodes) {
    StatusCodes[StatusCodes["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    StatusCodes[StatusCodes["OK"] = 200] = "OK";
})(StatusCodes || (exports.StatusCodes = StatusCodes = {}));
var HttpMethods;
(function (HttpMethods) {
    HttpMethods["OPTIONS"] = "OPTIONS";
    HttpMethods["ANY"] = "ANY";
    HttpMethods["POST"] = "POST";
    HttpMethods["GET"] = "GET";
})(HttpMethods || (exports.HttpMethods = HttpMethods = {}));
const getLambdaProxyResponse = (responseBody, statusCode) => {
    debug && console.log('response body in lambda response', responseBody);
    return {
        statusCode,
        headers: {
            'Access-Control-Allow-Credentials': true,
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify(responseBody, iotv_v3_types_1.replaceErrors),
        isBase64Encoded: false,
    };
};
exports.getLambdaProxyResponse = getLambdaProxyResponse;
const getLambdaProxyError = (context) => {
    return {
        errorType: 'InternalServerError',
        httpStatus: StatusCodes.INTERNAL_SERVER_ERROR,
        requestId: context?.awsRequestId,
        message: 'An unknown error has occurred. Please try again.',
    };
};
exports.getLambdaProxyError = getLambdaProxyError;
